import parse from 'html-react-parser'
import dynamic from 'next/dynamic'
import Header from '../components/header'
import MetaTags from '../components/MetaTags'
const Footer = dynamic(() => import('../components/footer'))
import Noresults from '../components/noresults';
const MiniCart = dynamic(() => import('../components/cart/minicart'))
import Scripts from '../components/scripts';

function LandingPage({ item, menu, config }) {

  return (
    <>
     
      <MetaTags item={item} config={config}></MetaTags>
      
      <div className="wrapper h-full flex flex-col">
        <Header menu={menu} config={config}></Header>
        {(item && item.description) ? (
          parse(item.description)
        ) : (
          <Noresults></Noresults>
        )}
        <Footer menu={menu} config={config}></Footer>
      </div>
      <MiniCart></MiniCart>
      <Scripts javascripts={item.javascripts}></Scripts>
    </>
  )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
  const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
  const config_data = await config_res.json()
  const config = config_data.data

  const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
  const menu = await menu_res.json()

  const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/landingpage/' + context.params.url)
  const response = await res.json()
  const page = (response.status) ? (response.data) : (false)


  if (!page) {
    return {
      notFound: true
    }
  }

  return {
    props: {
      config: config,
      menu: menu,
      item: page,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 600, // In seconds

  }
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// the path has not been generated.
export async function getStaticPaths() {
  const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/landingpage')
  const response = await res.json()
  const pages = response.data.data

  // Get the paths we want to pre-render based on products
  const paths = pages.map((page) => ({
    params: {
      url: page.url.toString(),
    },
  }))

  // We'll pre-render only these paths at build time.
  // { fallback: blocking } will server-render pages
  // on-demand if the path doesn't exist.
  return { paths, fallback: 'blocking' }
}


export default LandingPage